import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { SpeechinputmodalPageRoutingModule } from './speechinputmodal-routing.module';

import { SpeechinputmodalPage } from './speechinputmodal.page';
import { SharedModule } from '../shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    SpeechinputmodalPageRoutingModule
  ],
  declarations: [SpeechinputmodalPage]
})
export class SpeechinputmodalPageModule {}
